"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditFacilityContingentLiabilityProducts = exports.ReceivableResponseTapePreviewReportTypeIterable = exports.LenderShareReportTypeIterable = exports.InvoiceReportTypeIterable = exports.FundingRequestReportTypeIterable = exports.CreditFacilityReportTypeIterable = exports.BorrowingBaseServicerReportTypeIterable = exports.BatchSettlementReportTypeIterable = exports.AssignedLoanTapeReportTypeIterable = exports.ComplianceReportCfTypeIterable = exports.MetricKey = exports.ManualBankAccountReportSource = exports.WEBHOOK_EVENT_TYPES = exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = exports.BankAccountWithInstitutionSchema = exports.BankInstitutionKeySchema = exports.DocumentTypeIterable = exports.FacilityTypeIterable = exports.TellerEnrollmentStatus = exports.ArtifactWithSlugsSchema = exports.ArtifactInstance = exports.ArtifactTypeIterable = exports.UserInputTypeSchema = exports.GeneratedArtifactTypeIterable = exports.NON_SHADOWED_TABLES = exports.SANDBOX_ONLY_TABLES = exports.SHADOWED_TABLES = void 0;
const BankTypes = __importStar(require("./Bank"));
const v4_1 = require("zod/v4");
// TODO(jon): these are currently sorted in the order they were added to the sandbox. Leaving them
//  this way for now for easy auditing, but once the sandbox stabilizes we should alphabetize.
/**
 * Tables present in both sandbox and live schemas. Definitions must match between schemas and will
 * be checked by the `schemaSync` script.
 */
exports.SHADOWED_TABLES = [
    'borrowing_base_pipeline_artifact_instances',
    'master_loan_tapes',
    'assigned_loan_tapes',
    'receivables',
    'receivable_events',
    'reports',
    'reports_v2',
    'reports_to_entity_map',
    'cash_balances_feed_contexts',
    'cash_balances_feed_screenshots',
    'manual_bank_account_reports',
    'bank_account_reports',
    'cash_response_tapes',
    'borrowing_base_reports',
    'borrowing_base_report_attachments',
    'borrowing_base_report_loan_product_calculations',
    'funding_request_constraints',
    'eligibility_criteria_calculations',
    'concentration_limit_calculations',
    'accounting_accounts',
    'accounting_transactions',
    'accounting_entries',
    'events',
    'event_logs',
    'funding_request_verification_reports',
    'funding_request_approval_reports',
    'funding_requests',
    'funding_request_components',
    'proforma_funding_request_components_map',
    'credit_agreements',
    'credit_agreement_parties',
    'funding_request_receivable_eligibility_verification',
    'borrower_cash_balances_feed',
    'borrowing_base_pipeline_artifact_documents',
    'borrowing_base_pipeline_artifacts',
    'borrowing_base_pipeline_artifact_dependencies',
    'borrowing_base_pipeline_runs',
    'borrowing_base_pipeline_deleted_instances', // @pipeline_runs: this is a temporary table for pipeline_run_table migration
    'internal_repayment_tapes',
    'assigned_repayment_tapes',
    'repayment_entries_credit_facility',
    'tape_builder_graph_nodes',
];
/** Tables present in sandbox but not in live. */
exports.SANDBOX_ONLY_TABLES = [];
/** Tables present in live but not in sandbox. */
exports.NON_SHADOWED_TABLES = [
    'assigned_loan_tape_reports',
    'assignment_confirmation_jobs',
    'assignment_strategies',
    'assignment_strategy_loan_product_criteria',
    'async_operations',
    'athena_queries',
    'bank_account_refreshes',
    'bank_accounts',
    'bank_institutions',
    'borrowing_base_pipeline_definitions',
    'borrowing_base_servicer_reports',
    'compliance_reports_cf',
    'cdq_config',
    'cdq_acknowledgements',
    'concentration_limit_multi_loan_product_calculations',
    'connected_organizations',
    'covenant_loan_tapes',
    'credit_facilities_v2_prep',
    'credit_facilities',
    'credit_facility_balance_sheet_data',
    'credit_facility_outstanding_balance_ledger_items',
    'credit_facility_reports',
    'credit_facility_state',
    'org_provided_inputs',
    'org_provided_values',
    // *** Credit Facility Loans ***
    'credit_facility_loan_actions',
    'credit_facility_loan_connections',
    'credit_facility_lender_shares',
    'credit_facility_loans',
    'credit_facility_loan_pricing_options',
    'credit_facility_lender_shares_transactions',
    'credit_facility_lender_share_reports',
    'lender_share_funding_components',
    'credit_facility_batch_settlements',
    'credit_facility_batch_settlement_loan_connections',
    'credit_facility_batch_settlement_reports',
    // *** Credit Facility - Other Products (not loans) ***
    'credit_facility_contingent_liabilities',
    'credit_facility_contingent_liability_transactions',
    'credit_facility_documents',
    'datalake_tables',
    'datalake_hydration_event_jobs',
    'deliverable_tasks',
    'deliverables_artifacts_instances',
    'deliverables_artifacts',
    'deliverables_containers',
    'deliverables_containers_to_threads_mapping',
    'deliverables_containers_receipts',
    'deliverables_containers_receipts_actions_log',
    'deliverables_containers_generate_receipts',
    'deliverables_artifacts_instances_datalake_hydration_status',
    // next two tables are deliverables workflows tables
    'deliverables_containers_receipt_workflows_map',
    'deliverables_containers_receipt_user_approvals',
    'explo_placement_integrations',
    'external_metadata',
    'financial_statement_values',
    'financial_statements',
    'financial_statement_line_items',
    'financial_covenants',
    'finley_ai_knowledge_base_documents',
    'finley_ai_threads',
    'finley_ai_prompt_responses',
    'finley_ai_prompt_templates',
    'funding_request_events',
    'funding_request_reports',
    // following two tables are FR workflow tables
    'funding_request_user_approvals',
    'funding_request_workflow_instance_map',
    `funding_requests_to_threads_mapping`,
    'groups',
    'group_memberships',
    'implementations',
    'implementation_pipelines',
    'invoices',
    'invoice_components',
    'invoice_items',
    'invoice_consolidated_disbursements',
    'invoice_disbursements',
    'invoice_disbursement_items',
    'invoice_disbursement_items_transactions',
    'invoice_payment_in_kind_items',
    'invoice_payment_in_kind_items_transactions',
    'invoice_reports',
    'loan_products',
    'loan_product_balance_sheet_data',
    'materialized_view_configuration',
    'metric_alert_state',
    'metric_alert_thresholds',
    'organizations',
    'api_keys',
    'plaid_asset_report_accounts',
    'plaid_asset_reports',
    'plaid_institution_accounts',
    'plaid_items',
    'portfolio_covenants',
    'railz_financial_api_results',
    'railz_integrations',
    'receivable_documentation_generated',
    'receivable_documentation_raw',
    'receivable_documentation_verification_results',
    'receivable_response_tape_preview_attachments',
    'receivable_response_tape_preview_jobs',
    'receivable_response_tape_previews',
    'receivable_response_tape_preview_reports',
    'reporting_docx_template_customizations',
    'reporting_generate_worklease_status',
    'report_templates',
    'report_xlsx_template_properties',
    'teller_institution_accounts',
    'teller_item',
    'users',
    'webhook_attempts',
    'webhook_subscriptions',
    'valley_bank_van_cust',
    'valley_bank_van_dep_acct',
    'valley_bank_van_cust_acct_rel',
    'valley_bank_van_list',
    'valley_bank_van_product',
    'valley_bank_loan_cust_rel',
    'valley_bank_cuo_deposit',
    'valley_bank_cuo_collat',
    'valley_bank_collat_cust_rel',
    'valley_bank_ps_plus_portfolio',
    'valley_bank_ps_plus_account',
    'valley_bank_ps_plus_sec_detail',
    'valley_bank_ps_plus_sec_master',
    'valley_bank_van_cmmt',
    'valley_bank_van_loan_acct',
    'valley_bank_cuo_loan',
    'valley_bank_cuo_maint',
    'valley_bank_rrt', // FinleyValleyBankResponseTapeRow
    'valley_bank_portfolio_rrt', // portfolio view of rrt
    'valley_bank_assignment_queue',
    'valley_bank_assignment_event_log',
    'valley_bank_collateral_account_stats',
    'valley_bank_loan_account_stats',
    'valley_bank_loan_accounts_to_threads_mapping',
    'valley_bank_historical_loan_account_to_pinned_comment',
    'valley_bank_derivative_path',
    'valley_ibs_api_records',
    'valley_sls_ibs_transaction_tapes',
    'valley_sls_ibs_transactions',
    'valley_sls_ibs_transaction_groups',
    'valley_sls_ibs_transaction_mappings',
    'receivable_borrowing_base_test_waivers',
    'statements',
    'threads',
    'comments',
    'domain_to_threads_mapping',
    'table_preferences',
    'thread_permissions',
    'thread_user_actions_log',
    'workflow_templates',
    'workflow_instances',
    'workflow_nodes',
    'workflow_edges',
    'workflow_actions',
    'workflow_conditions',
    'tasks',
    'permissions',
    'roles',
    'role_permissions',
    'role_assignments',
    'limited_partners',
    'limited_partners_to_loan_product_mapping',
    'limited_partner_match_metadata',
    'config_store',
    'attributes',
    'attribute_values',
    'attribute_lists',
    'lender_interest_rates',
];
exports.GeneratedArtifactTypeIterable = [
    'generatedCovenantLoanTape',
    'generatedLoanTape',
    'generatedCashBalanceFeed',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
    'generatedFinancialData',
];
exports.UserInputTypeSchema = v4_1.z.enum([
    'assignement',
    'verificationApproval',
    'dataLakeTableHydration',
    'cashContext',
]);
exports.ArtifactTypeIterable = [
    ...exports.GeneratedArtifactTypeIterable,
    'userInputNeeded', // this task indicates that the pipeline needs input from the user
    'rawLoanTape',
    'rawCashBalanceFeed',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'rawZipTape', // this special raw artifact type is handled by the ingest-organizer-lambda
    'configTape',
    'rawReceivableDocumentation',
    'intermediateTape',
    'internalRepaymentTape',
    'cashResponseTape',
    'cashBalancesFeedContext',
    'masterLoanTape',
    'manualBankAccountReport',
    'assignedLoanTape',
    'assignedRepaymentTape',
    'receivableResponseTapePreview',
    'receivableResponseTape',
    'borrowingBaseReport',
    'directInsertBorrowingBaseReport',
    'directInsertPortfolioCovenant',
    'directInsertPortfolioCovenants',
    'directInsertFinancialCovenants',
    'finStatement',
    'receivableInvoice',
    'fundingVerificationReport',
    'fundingApprovalReport',
    'fundingRequest',
    'receivableDocumentationVerificationReport',
    'forwardedTape',
    'valleyBankIngest',
    'valleyBankSlsIngest',
    'valleyBankSlsCommitment',
    'orgProvidedInput',
    'orgProvidedInputs',
    'uploadToDatalake',
    'waitForDataLakeTable', // task that waits for a data lake table to be ready
    'dataLakeTape', // task that generates a csv file from a data lake query
    'limitedPartnersTape',
];
var ArtifactInstance;
(function (ArtifactInstance) {
    /** Uniqueness constraint exists on the table. */
    ArtifactInstance.ArtifactInstanceStatuses = [
        'initializing',
        'inProgress',
        'error',
        'success',
    ];
})(ArtifactInstance || (exports.ArtifactInstance = ArtifactInstance = {}));
// Zod schema for ArtifactWithSlugs
exports.ArtifactWithSlugsSchema = v4_1.z.object({
    // All fields from Artifact except creditFacilityId and loanProductId
    id: v4_1.z.string(),
    artifactSlug: v4_1.z.string(),
    artifactDocumentId: v4_1.z.string(),
    type: v4_1.z.string(), // ArtifactType, but as string for schema
    externalFilename: v4_1.z.string().nullable(),
    configuration: v4_1.z.object({}),
    // Add the slug fields
    creditFacilitySlug: v4_1.z.string().nullable(),
    loanProductSlug: v4_1.z.string().nullable(),
});
var TellerEnrollmentStatus;
(function (TellerEnrollmentStatus) {
    TellerEnrollmentStatus["Connected"] = "connected";
    TellerEnrollmentStatus["Disconnected"] = "disconnected";
    TellerEnrollmentStatus["AccountLocked"] = "accountLocked";
    TellerEnrollmentStatus["Inactive"] = "inactive";
    TellerEnrollmentStatus["CredentialsInvalid"] = "credentialsInvalid";
    TellerEnrollmentStatus["CaptchaRequired"] = "captchaRequired";
    TellerEnrollmentStatus["MfaRequired"] = "mfaRequired";
    TellerEnrollmentStatus["WebLoginRequired"] = "webLoginRequired";
})(TellerEnrollmentStatus || (exports.TellerEnrollmentStatus = TellerEnrollmentStatus = {}));
exports.FacilityTypeIterable = [
    'creditFacility',
    'forwardFlow',
    'securitization',
    'capitalCallLine',
];
/******************** CreditFacility Document Types ********************/
exports.DocumentTypeIterable = [
    'creditAgreement',
    'participationAgreement',
];
const DocumentStatusIterable = ['latestPublished', 'published'];
exports.BankInstitutionKeySchema = v4_1.z.string();
const BankAccountSchema = v4_1.z.object({
    id: v4_1.z.string(),
    name: v4_1.z.string(),
    isActive: v4_1.z.boolean(),
    implementationId: v4_1.z.string(),
    organizationId: v4_1.z.string(),
    plaidAccountId: v4_1.z.optional(v4_1.z.string().nullable()),
    tellerAccountId: v4_1.z.optional(v4_1.z.string().nullable()),
    bankInstitutionId: v4_1.z.string(),
    routingNumber: v4_1.z.string(),
    accountNumber: v4_1.z.string(),
    currencyCode: BankTypes.CurrencyCodeSchema,
});
const ImplementationBankAccountSchema = BankAccountSchema.extend({
    implementationId: v4_1.z.string(),
    // @implementation: support API integrations with implementation-owned bank accounts.
    // This will require split auth - implementation owner owns the bank account, but the
    // real life bank account owner owns the API integration.
    plaidAccountId: v4_1.z.null(),
    tellerAccountId: v4_1.z.null(),
});
exports.BankAccountWithInstitutionSchema = BankAccountSchema.extend({
    institutionName: v4_1.z.string(),
    bankInstitutionKey: exports.BankInstitutionKeySchema,
});
exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = ['assignment.assign'];
exports.WEBHOOK_EVENT_TYPES = [
    ...exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES,
    'fundingRequest.approved',
    'borrowingBaseReport.generated',
];
var ManualBankAccountReportSource;
(function (ManualBankAccountReportSource) {
    ManualBankAccountReportSource["AdminDashboard"] = "adminDashboard";
    ManualBankAccountReportSource["BorrowerDashboard"] = "borrowerDashboard";
    ManualBankAccountReportSource["BorrowerS3Upload"] = "borrowerS3Upload";
})(ManualBankAccountReportSource || (exports.ManualBankAccountReportSource = ManualBankAccountReportSource = {}));
var MetricKey;
(function (MetricKey) {
    MetricKey["collateralCovenantLtv"] = "collateralCovenantLtv";
})(MetricKey || (exports.MetricKey = MetricKey = {}));
// At the moment, this would generally align with "ReportConfigTypeIterable" in
// "CreditAgreement.DomainEntity", potentially being a subset of it.
exports.ComplianceReportCfTypeIterable = [
    'monthlyServicerReport',
];
exports.AssignedLoanTapeReportTypeIterable = [
    'receivablesSaleAgreement',
];
exports.BatchSettlementReportTypeIterable = ['batchSettlement'];
exports.BorrowingBaseServicerReportTypeIterable = [
    'borrowingBaseServicerReport',
];
exports.CreditFacilityReportTypeIterable = ['assetVerification'];
exports.FundingRequestReportTypeIterable = [
    'borrowingBaseCertificate',
    'fundingRequestServicerReport',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'releaseNotice',
];
exports.InvoiceReportTypeIterable = [
    'invoice',
    'disbursementNotice',
    'paymentInKindNotice',
];
exports.LenderShareReportTypeIterable = ['fundingNotice'];
exports.ReceivableResponseTapePreviewReportTypeIterable = [
    'receivableResponseTapePreviewServicerReport',
];
const threadDomains = [
    'fundingRequest.request',
    'valleyBank.loanAccountNumber',
    'deliverables.container',
    'limitedPartner',
    'invoice',
];
exports.CreditFacilityContingentLiabilityProducts = [
    'letterOfCredit',
];
//# sourceMappingURL=DbTables.js.map